<div class="submit-docs-box flex flex-col p-16">
  <div class="h-[70px] self-center">
    <mat-icon class="text-[60px]! w-[60px]! h-[40px]! mb-35 text-charcoal-50!">send</mat-icon>
  </div>
  <div class="title-1 mb-15">Send To {{ assessorName }}</div>
  @if (!submitting() && !errorMessage()) {
    <div class="text-charcoal-50! mb-10 subtitle-1">
      {{ sendingDocumentsMessage }}
    </div>

    @if (hasRepairerCommentWarning) {
      <div class="flex text-left gap-x-5 mb-10 body-2 text-red">
        <mat-icon class="text-red!"> warning </mat-icon>
        NO ACTION WILL BE TAKEN REGARDING COMMENTS CONCERNING FACTORED INVOICES, YOUR AGREEMENT ALLOWS USE OF THE
        PLATFORM AS PROVIDED
      </div>
    }
  }

  @if (errorMessage()) {
    <div class="my-10">
      <div class="warn-box">
        <mat-icon matPrefix>report_problem</mat-icon>
        <div>
          There was a problem sending some of the items you submitted to the insurer. Please try again or contact
          Support.
        </div>
      </div>
    </div>
  }

  @if (submitting()) {
    <mat-progress-bar class="progress-bar" mode="buffer" />
    <div class="text-charcoal-60 mt-10 mb-15 body-2">
      <div>Sending...</div>
      <div>This should only take a few seconds</div>
    </div>
  } @else {
    <mat-divider class="mb-10!" />

    @if (errorMessage()) {
      <button matButton="text" class="w-[150px] self-center" mat-dialog-close>OK</button>
    } @else {
      <div class="flex justify-between">
        <button matButton="elevated" class="charcoal-button w-[150px]" mat-dialog-close>CANCEL</button>
        <button matButton="elevated" class="red-button w-[150px]" (click)="submitJob()">
          <mat-icon>send</mat-icon>
          SEND
        </button>
      </div>
    }
  }
</div>
